/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSovSummaryQueryDto
 */
export interface GetSovSummaryQueryDto {
    /**
     * 
     * @type {string}
     * @memberof GetSovSummaryQueryDto
     */
    submissionId: string;
}

/**
 * Check if a given object implements the GetSovSummaryQueryDto interface.
 */
export function instanceOfGetSovSummaryQueryDto(value: object): value is GetSovSummaryQueryDto {
    if (!('submissionId' in value) || value['submissionId'] === undefined) return false;
    return true;
}

export function GetSovSummaryQueryDtoFromJSON(json: any): GetSovSummaryQueryDto {
    return GetSovSummaryQueryDtoFromJSONTyped(json, false);
}

export function GetSovSummaryQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSovSummaryQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'submissionId': json['submissionId'],
    };
}

export function GetSovSummaryQueryDtoToJSON(json: any): GetSovSummaryQueryDto {
    return GetSovSummaryQueryDtoToJSONTyped(json, false);
}

export function GetSovSummaryQueryDtoToJSONTyped(value?: GetSovSummaryQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submissionId': value['submissionId'],
    };
}

